
define('text!templates/modules/calendar/activity/detail/blocks/details-form.html',[],function () { return '<div class="form-title"></div>\n<div class="form-description"></div>\n<div class="form-date"></div>\n';});

